<script>
export default {
	lang: 'shop',
	data() {
		return {
			isMounted: false,
			logo: this.$srv('CheckoutAppBar.logo'),
			backColor: this.$srv('CheckoutAppBar.backColor'),
			textColor: this.$srv('CheckoutAppBar.textColor'),
		}
	},
	methods: {
		keepBuying() {
			window.location.href = this.$router.resolve(this.$shop.getShopRoute()).href
		},
	},
	mounted() {
		this.isMounted = true
		this.$vuetify.breakpoint.smAndDown && window.toggleChat?.(false)
	},
	beforeDestroy() {
		this.$vuetify.breakpoint.smAndDown && window.toggleChat?.(true)
	},
	cssVars: {
		selector: '.shop-app',
	},
}
</script>

<template>
	<div>
		<div :style="{ 'background-color': backColor, 'z-index': 1 }" class="py-4 elevation-4">
			<v-container class="d-flex align-center pa-0">
				<SafeLink to="/">
					<Media :src="logo" class="mr-2" />
				</SafeLink>
				<v-spacer />
				<Button text :color="textColor" small @click="keepBuying">
					<div class="preline">
						{{ $vuetify.breakpoint.xs ? $langText('Seguir\nComprando') : $lang('Seguir Comprando') }}
					</div>
				</Button>
			</v-container>
		</div>
		<v-main class="grey lighten-3 pt-2" v-if="isMounted">
			<router-view />
		</v-main>
	</div>
</template>
